module.exports = __webpack_public_path__ + "media/components/country-flag/static/mg-948d27d4f2554a7d4d99836ee8a18098.svg";